// extracted by mini-css-extract-plugin
export default {"heading":"AddCreative_heading__v9+9G","wrapper":"AddCreative_wrapper__V7eaL"};